export default "__VITE_ASSET__dRimh2mZ__"